import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=0d1e5f5b&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=ts&"
export * from "./JobDetails.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=0d1e5f5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e5f5b",
  null
  
)

export default component.exports